import { render, staticRenderFns } from "./16.vue?vue&type=template&id=5b5c2c94&scoped=true&"
import script from "./16.vue?vue&type=script&lang=js&"
export * from "./16.vue?vue&type=script&lang=js&"
import style0 from "./16.vue?vue&type=style&index=0&id=5b5c2c94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5c2c94",
  null
  
)

export default component.exports